import { TransformedEvent } from "../ParsingUtil";
import { MultilineTextLayout, PDFDocument } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";

const TEXT_SIZE = 15;
const DATE_SIZE = 20;
const TITLE_SIZE = 14;

export const getLineLength = (layout: MultilineTextLayout) => {
  return layout.lines.length;
};

export const getTexts = {
  date: (item: TransformedEvent) => {
    const day = item.start.getDate().toString().padStart(2, "0");
    const month = (item.start.getMonth() + 1).toString().padStart(2, "0");
    const year = item.start.getFullYear();
    return `${day}.${month}.${year}`;
},
  title: (item: TransformedEvent) => {
    return item.title.replace(/<[^>]*>/g, "");
  },
  description: (item: TransformedEvent) => {
    return item.resource.description.replace(/<[^>]*>/g, "");
  },
  link: (item: TransformedEvent) => {
    let allLinks: string[] = [];
    if (
      item.resource.link.length === 1 &&
      item.resource.link[0].trim().slice(0, 5) !== "https"
    ) {
      allLinks.push("nothing_to_link");
      return allLinks;
    } else {
      item.resource.link.forEach((lexwareLink) => {
        if (lexwareLink.split("|")[0].trim().slice(0, 5) === "https") {
          allLinks.push(lexwareLink.split("|")[0].trim());
        }
      });
      return allLinks;
    }
  },
};

export const allLinesLength = (
  dateLayout: MultilineTextLayout,
  titleLayout: MultilineTextLayout,
  descriptionLayout: MultilineTextLayout,
  linkLayout: MultilineTextLayout
) => {
  return (
    getLineLength(dateLayout) * DATE_SIZE +
    getLineLength(titleLayout) * TITLE_SIZE +
    getLineLength(descriptionLayout) * TEXT_SIZE +
    getLineLength(linkLayout) * TEXT_SIZE
  );
};

export const addMetaData = (pdfDoc: PDFDocument) => {
  pdfDoc.setCreator("www.lexware.de");
  pdfDoc.setTitle("Lexware Unternehmerkalender");
  pdfDoc.setAuthor("lexware");
  pdfDoc.setSubject("Alle wichtige Termine für Unternehmen");
  pdfDoc.setKeywords([
    "Steuern,",
    "Buchhaltung & Finanzen,",
    "Mitarbeiter & Gehalt,",
    "Unternehmensführung,",
  ]);
  pdfDoc.setProducer("www.lexware.de");
};

export const currentYear = new Date().getFullYear();

export const getCustomFonts = async (pdfDoc: PDFDocument) => {
  const urlSans = "./Urbanist-Bold.ttf";
  const urlBold = "./Urbanist-ExtraBold.ttf";
  const urlItalic = "./Urbanist-SemiBold.ttf";
  const fontBytesSans = await fetch(urlSans).then((res) => res.arrayBuffer());
  const fontBytesBold = await fetch(urlBold).then((res) => res.arrayBuffer());
  const fontBytesItalic = await fetch(urlItalic).then((res) =>
    res.arrayBuffer()
  );
  pdfDoc.registerFontkit(fontkit);
  const haufefontSans = await pdfDoc.embedFont(fontBytesSans);
  const haufeFontItalic = await pdfDoc.embedFont(fontBytesItalic);
  const haufeFontBold = await pdfDoc.embedFont(fontBytesBold);

  return { haufefontSans, haufeFontItalic, haufeFontBold };
};

export const removeHtmlTags = (inputText: string) => {
  return inputText.replace(/<[^>]*>/g, "");
};
